import { Currency, ErrorResponse, Program } from '@citruscamps/citrus-client'
import { useQuery } from 'react-query'
import { toCurrency } from '../../../utils/currency'

interface CitrusPromotion {
  referral: Currency
}

interface IProps {
  program?: Program
}

interface FetchCitrusPromotion {
  data?: CitrusPromotion
  isLoading: boolean
  isError: boolean
  error: ErrorResponse | null
}

export const useFetchCitrusPromotion = ({ program }: IProps): FetchCitrusPromotion => {
  const { data, error, isError, isLoading } = useQuery<CitrusPromotion, ErrorResponse>(
    ['citrus-promotion'],
    async () => {
      if (!program?.id) {
        throw new Error('Unable to fetch data')
      }
      return {
        referral: toCurrency({
          amount: 200,
          currency: program.default_currency,
          language: program.language,
        }),
      }
    },
    { enabled: !!program?.id },
  )

  return {
    data,
    error,
    isError,
    isLoading,
  }
}
